<template lang="pug">
  a-modal(
    :title="title"
    :maskClosable="false"
    :visible="true"
    :confirmLoading="loading"
    @ok="handleSubmit()"
    :okText="$t('components.my_data_modal.tpl.save')"
    @cancel="hideModal()"
    :cancelText="$t('components.my_data_modal.tpl.cancel')"
  )
    a-form(
      @submit.prevent="handleSubmit()"
    )
      input(
        type="submit"
        v-show="false"
      )
      a-form-item(
        :label="$t('components.my_data_modal.tpl.email_label')"
        :validate-status="mailValidateStatus"
        :help="mailHelp"
      )
        a-input(
          v-model="mutableMail"
          :disabled="loading"
          required
        )
      a-form-item(
        :label="$t('components.my_data_modal.tpl.username_label')"
      )
        a-input(
          v-model="user.username"
          :disabled="true"
          required
        )
      a-form-item(
        :label="$t('components.my_data_modal.tpl.name_and_surnames_label')"
      )
        a-input(
          v-model="mutableName"
          :disabled="loading"
        )
</template>

<script>
import {
  mapActions,
  mapState,
  mapGetters,
} from 'vuex';
import { isEmpty, some } from 'lodash';

import { searchUsersBy } from '@/api';

const DEFAULT_MAIL_VALIDATE_STATUS = null;
const DEFAULT_MAIL_HELP = null;

export default {
  data() {
    return {
      title: this.$t('components.my_data_modal.js.title'),
      loading: false,
      mutableName: '',
      mutableMail: '',
      mailValidateStatus: DEFAULT_MAIL_VALIDATE_STATUS,
      mailHelp: DEFAULT_MAIL_HELP,
    };
  },
  computed: {
    ...mapState('login', {
      user: state => state.user,
    }),
    ...mapGetters('login', [
      'FORMATTED_TOKEN',
    ]),
  },
  created() {
    this.mutableName = this.user.name;
    this.mutableMail = this.user.mail;
  },
  methods: {
    ...mapActions('login', [
      'updateAndSetUser',
    ]),
    async hideModal() {
      await this.$emit('hide');
    },
    async handleSubmit() {
      this.loading = true;
      this.mailValidateStatus = DEFAULT_MAIL_VALIDATE_STATUS;
      this.mailHelp = DEFAULT_MAIL_HELP;

      try {
        const users = await searchUsersBy({
          token: this.FORMATTED_TOKEN,
          mail: this.mutableMail,
        });

        if (!isEmpty(users) && !some(users, { mail: this.user.mail })) {
          // https://vuecomponent.github.io/ant-design-vue/components/form/#Form.Item
          this.mailValidateStatus = 'error';
          this.mailHelp = this.$t('components.my_data_modal.js.mail_help');
          this.loading = false;
          return;
        }
        await this.updateAndSetUser({
          id: this.user.id,
          name: this.mutableName,
          mail: this.mutableMail,
        });
        await this.hideModal();
        this.loading = false;
        this.$notification.success({
          message: this.$t('components.my_data_modal.js.success_message'),
          description: this.$t('components.my_data_modal.js.success_description'),
          placement: 'bottomRight',
          duration: 4,
        });
      } catch (e) {
        this.loading = false;
        this.$message.error(this.$t('components.my_data_modal.js.error_message'), 2);
      }
    },
  },
};
</script>
